
import { Component, OnDestroy, OnInit, output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter, Subscription, Observable, finalize } from "rxjs";
import { MenuItem } from "primeng/api";
import { MenuModule } from "primeng/menu";
import {
  SessionData,
  SessionService,
} from "../../../../Utils/_services/session/session.service";
import { environment } from "../../../../environments/environment";
import { AdminService } from "../../../../Utils/_services/admin/admin/admin.service";
import { SocketService } from "../../../../Utils/_services/socket/socket.service";
import { AdminSecurityService } from "../../../../Utils/_services/admin/security/security.service";
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: "app-header",
  standalone: true,
  imports: [MenuModule],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private sessionService: SessionService,
    private adminService : AdminService,
    private socketService: SocketService,
    private adminSecurityService: AdminSecurityService,
    private cdr: ChangeDetectorRef
  ) {}

  toggleSidebar = output<void>();
  pageTitle = "";
  private sub?: Subscription;
  sessionData!: SessionData | null;
  profilePhotoUrl: string | null = null;
  menuItems: MenuItem[] = [];
  unreadCount: number = 0;
  private unreadCountSub?: Subscription;

  ngOnInit(): void {
    this.computePageTitle();
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.computePageTitle());

    this.sessionService.sessionData$.subscribe(data => {
      this.sessionData = data;
      if(this.sessionData) {
        this.getUserById();
        this.fetchUnreadAlertsCount();
      }
    });

    // Subscribe to shared unread count (updated by socket & mark-as-read actions)
    this.unreadCountSub = this.adminSecurityService.unreadCount$.subscribe((count) => {
      this.unreadCount = count;
      this.cdr.detectChanges();
    });

    // Remove the separate socket subscription — SocketService now drives unreadCount$ directly
    this.menuItems = [
      {
        label: "Profile",
        icon: "pi pi-user",
        command: () => this.goToProfile(),
      },
      {
        separator: true,
      },
      {
        label: "Go Home",
        icon: "pi pi-home",
        command: () => this.goHome(),
      },
      {
        separator: true,
      },
      {
        label: "Go PWA",
        icon: "pi pi-desktop",
        command: () => this.goPWA(),
      },
      {
        separator: true,
      },
      {
        label: "Logout",
        icon: "pi pi-sign-out",
        command: () => this.logout(),
      },
    ];
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.unreadCountSub?.unsubscribe();
  }
getUserById() {
  const id = this.sessionData?.user?._id;
  if (!id) return;

  this.adminService.getUserById(id).pipe(
    finalize(() => {})
  ).subscribe({
    next: (res) => {
      const primaryPhoto = res.data.profilePhotos?.find((p: any) => p.isPrimary);
      this.profilePhotoUrl = primaryPhoto?.signedUrl ?? null;
    },
    error: (err) => {
      console.error('Error fetching user:', err);
    }
  });
}
  fetchUnreadAlertsCount() {
    this.adminSecurityService.getAdminAlerts(1, 1).subscribe({
      next: (res) => {
        if (res.data) {
          this.adminSecurityService.setUnreadCount(res.data.totalUnread || 0);
        }
      },
      error: (err) => console.error('Error fetching unread alerts count:', err)
    });
  }

  get greeting(): string {
    const h = new Date().getHours();
    if (h < 12) return "Good Morning";
    if (h < 17) return "Good Afternoon";
    return "Good Evening";
  }

  get breadcrumb(): string {
    return `Admin / ${this.pageTitle}`;
  }

  private computePageTitle(): void {
    const url = this.router.url || "";
    const segments = url.split("?")[0].split("#")[0].split("/").filter(Boolean);
    // Prefer last meaningful segment as title
    const last = segments[segments.length - 1] || "";
    this.pageTitle = this.toTitleCase(last.replace(/[-_]/g, " "));
  }

  private toTitleCase(s: string): string {
    return s
      .split(" ")
      .filter(Boolean)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  private goHome() {
    this.router.navigate(["/"]);
  }

  private goPWA() {
    // GET JWT and user data to forward to PWA login
    const userData = this.sessionService.getCurrentUser();
    if (userData) {
      const adoreTheBallonUrlPlusJwt = `${environment.pwaFrontendBaseUrl}/login?id=${encodeURIComponent(userData.uuidv4Id)}`;
      window.open(adoreTheBallonUrlPlusJwt, "_blank");
    }
  }

  private logout() {
    try {
      this.sessionService.clearSession();
      localStorage.removeItem("user");
    } catch (err) {
      console.warn("Error clearing session on logout", err);
    }
    this.router.navigate(["/auth/login"]);
  }

  private goToProfile() {
    this.router.navigate(["/admin/profile"]);
  }

  goToNotifications() {
    this.router.navigate(["/admin/notifications"]);
  }
}
function takeUntilDestroyed(destroyRef: any): import("rxjs").OperatorFunction<import("../../../../Utils/_interceptors/network-error.model").IAppResponse<any>, unknown> {
  throw new Error("Function not implemented.");
}

